import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_EQUIPMENT_REQUEST_BY_ID_WITH_NOTES } from '../../../../../graphql/equipmentRequest/equipmentRequest.queries'

// components
import Card from '../../../../../components/cards/Card/Card.component'
import CardDataPoint from '../../../../../components/cards/CardDataPoint/CardDataPoint.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons'

export default function EquipmentRequestDetailNotes({ id }) {

    let request = {}

    const { loading, errors, data } = useQuery(GET_EQUIPMENT_REQUEST_BY_ID_WITH_NOTES, {
        variables: { id }
    })

    if(data && data.equipmentRequest) {
        request = data.equipmentRequest
    }

    return (<Card header={{ icon: <FontAwesomeIcon icon={faInfo} size='2x' color='#707070' />, title: "Notes"}}>
        <CardDataPoint label="" value={request.notes} />
    </Card>)
    
}